export default "__VITE_ASSET__DJnDHfe1__"